import { createConsola } from "consola/browser";

export const log = createConsola({
  level: 5
});
